import { debounce } from 'debounce'
export default {
    //  Calculate our height whenever we get mounted
    mounted() {
        this.calculateHeight()
    },
    computed: {
        hotKeysEnabled(): boolean {
            // Checks if our hotkeys are enabled or not
            return this.$store.getters.settingGet('hotKeysEnabled')
        }
    },
    methods: {
        //  This does the same exact thing as the auto-grow prop, but doing it manually means we can debounce it
        calculateHeight(): void {
            //  Grab our text box element
            const input = document.getElementById('message-text-box')

            //  If for some reason it doesn't exist, do nothing
            if (!input) return

            //  Set the height to 0 as default value
            input.style.height = '0'

            //  Grab the scroll height of our element
            const height = input.scrollHeight

            //  The minimum height is our rows * 24
            const minHeight = parseInt(this.rows, 10) * 24

            //  Calculate our new height
            const newHeight = Math.max(minHeight, height) + 'px'

            //  Update our inputs height
            input.style.height = newHeight
        },
        //  This is required because @change only applies onBlur
        keyboardSubmit(event: KeyboardEvent): void {
            //  Grab the target of our event
            const target = event.target as HTMLTextAreaElement

            //  Check if this is a text area or a div
            const textArea = target.nodeName === "TEXTAREA"

            //  Grab the text value from value if it is textarea, or innerText if div
            const value = textArea ? target.value : target.innerText

            //  Set our text to this value
            this.$emit('keyboardSubmit', value)
        },
        onInput: debounce(function (val: string): void {
            //  Emit the onInptu event
            this.$emit('onInput', val)

            //  Calculate our height with a debounce to avoid latency
            this.calculateHeight()
        }, 250),
        //  This uses .verify instead of .validate because sometimes this.text doesn't update fast enough for .validate
        async validate(text: string): Promise<boolean> {
            //  Verify our validation against our text
            const validation = await this.$validator.verify(text, this.validation)

            //  Grab the valid flag from our validation
            const valid = validation.valid

            //  Return our valid flag
            return valid
        },
        // Removes focus from the messagebox enabling user to use hotkeys again
        unFocus(selector: string): void {
            // If hotkeys are off, we just return
            if (!this.hotKeysEnabled.enabled) return

            // Get the messagebox html element and then blur it (removes focus)
            const dom = document.getElementById('message-text-box')

            //  Blur to remove focus
            dom.blur()
        }
    }
}
